/*eslint-disable no-shadow */
/**
 * Implements a mask to obscure the rest of the applications.
 * Pops a view into the center of the screen.
 * Layout allows for 3 places to inject content.
 * Uses a default template to conform to modal bootstrap classes
 * to leverage to bootstrap CSS for this component.
 */
define('glu/core/modal/modalView',['require','./layerView','../../util','../../layout','../../$','hbs!./modal.hbs','jui/core'],function(require) {
    'use strict';

    var AbsoluteView = require('./layerView'),
        util = require('../../util'),
        Layout = require('../../layout'),
        $ = require('../../$'),
        template = require('hbs!./modal.hbs'),
        index = 1050,
        increment = 10,
        STACK = 'stack';

    // for tabbable selector
    require('jui/core');

    function getStaticIndex() {
        return index;
    }

    function incrementIndex() {
        index += increment;
        return index;
    }

    function decrementIndex() {
        index -= increment;
        return index;
    }

    return AbsoluteView.extend({
        template: template,

        className: 'glu-modal',

        ui: {
            mask: '> .modal-backdrop',
            close: 'button.close',
            dialog: '> div > .modal-dialog',
            body: '> div > div > form > .modal-body',
            footer: '> div > div > form > .modal-footer',
            modal: '> .modal'
        },

        events: {
            'click .modal-footer button': 'handleButtonClick',
            'keypress': 'callHandleKeyPress',
            'keydown': 'callHandleKeyPress'
        },

        //explicit paths like this is to avoid the parent view/layout from pilfering
        //subviews elements. 
        regions: {
            header: '> div > div > form > .modal-header',
            body: '> div > div > form > .modal-body',
            footer: '> div > div > form > .modal-footer'
        },

        attributes: {
            'role': 'dialog',
            'tabindex': '-1',
            'aria-labelledby': 'modal-title',
            'aria-describedby': 'modal-body'
        },

        initialize: function(options) {
            AbsoluteView.prototype.initialize.call(this, options);
            this.maskFlag = (options.mask === false) ? false : true;
            this.type = options.type;
            this.message = options.message;
            this.title = options.title;
            this.icon = options.icon;
            this.modalClass = options.modalClass;
            this.buttons = options.buttons;
            this.stretch = options.stretch === false ? false : true;
        },

        hideMask: function() {
            this.ui.mask.hide();
            this.maskFlag = false;
        },

        showMask: function() {
            this.ui.mask.show();
            this.maskFlag = true;
        },

        toggleMask: function() {
            this.ui.mask.toggle();
            this.maskFlag = !this.maskFlag;
        },

        onRender: function() {
            if (this.maskFlag) {
                this.ui.mask.show();
            } else {
                this.ui.mask.hide();
            }

            this.$el.show(); //modal class has display:none this is necessary to override
            //however I think we should deprecate that rule in the CSS in favor of if the modal
            //exists it should be shown until it is removed from the DOM

            // This class is added to the body to disable scrolling behind the modal (taken from bootstrap)
            this.$el.parent().addClass('modal-open');

            if (this.bodyView) {
                this.body.show(this.bodyView); //use body view element over message object
            }

            if (this.stretch) {
                this.resizeHandle = util.bind(this.handleResize, this);
                window.addEventListener('resize', this.resizeHandle);
                this.ui.body.css('overflow', 'auto');
                this.ui.modal.css('overflow', 'hidden');
                this.handleResize();
            }

            this.determineFocus();

            if (this.collisionMode === STACK) {
                this.setIndex(incrementIndex());
            }

            this.trigger('show', this);
        },

        close: function() {
            if (this.isClosed) {
                return false;
            }

            this.$el.parent().removeClass('modal-open');

            if (this.stretch) {
                window.removeEventListener('resize', this.resizeHandle);
            }
            if (this.collisionMode === STACK) {
                decrementIndex();
            }

            AbsoluteView.prototype.close.call(this);
        },

        determineFocus: function() {
            var tabbables = this.getTabbables(this.$el);
            if (tabbables.length > 0) {
                tabbables.eq(0).focus();
            } else {
                this.ui.dialog.focus();
            }
        },

        templateHelpers: function() {
            return {
                type: this.type || 'standard',
                message: this.message,
                title: this.title,
                dialogIcon: this.icon,
                modalClass: this.modalClass,
                buttons: this.buttons
            };
        },

        getTabbables: function($el) {
            //this is a really funky way to get all the elements in a single jquery object that has
            //the close button explicitly on the end of the array.  This is required for the proper
            //tabbing logic.
            var $tabbables = $el.find(':tabbable').not('.close');
            return $($.merge($tabbables, $el.find('.close')));
        },

        callHandleKeyPress: function(e) {
            // allow the handleKeyPress function to be used by dialog.js 
            this.handleKeyPress(this.$el, e);
        },

        handleKeyPress: function($el, e) {
            if (e.keyCode !== $.ui.keyCode.TAB) {
                return;
            }

            e.preventDefault();

            var arr = this.getTabbables($el),
                targ = arr.filter(e.target);

            if (targ.length > 0) {
                var index = arr.index(targ);

                if (e.shiftKey) {
                    if (index > 0) {
                        return arr.eq(index - 1).focus();
                    } else {
                        return arr.eq(arr.length - 1).focus();
                    }
                } else {
                    if (index < arr.length - 1) {
                        return arr.eq(index + 1).focus();
                    }
                }
            }

            this.determineFocus($el); // pass-thru $el for dialog.js
            return;

        },

        handleResize: function() {
            //in the case where our ui.body isn't set the offset is undefined. (ie. grid manage columns has this issue)
            if (this.ui.body.offset() !== undefined) {
                var offset = this.ui.body.offset().top - parseInt($(window).scrollTop(), 10);

                var footerHeight = this.ui.footer.outerHeight();

                var dialogBottomMargin = parseInt(this.ui.dialog.css('margin-bottom'), 10);

                var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

                var maxHeight = h - (offset + footerHeight + dialogBottomMargin);

                this.ui.body.css('max-height', maxHeight + 'px');
            }
        },

        handleButtonClick: function(e) {
            var key = e.target.getAttribute('data-key');

            var button = this.buttons[key];

            if (button && button.callback && util.isFunction(button.callback)) {
                button.callback.call(this, e);
            } else if (button && button.callback && util.isString(button.callback) && util.isFunction(this[button.callback])) {
                this[button.callback].call(this, e);
            } else if (button && button.callback && util.isString(button.callback) && this.bodyView && util.isFunction(this.bodyView[button.callback])) {
                this.bodyView[button.callback].call(this.bodyView, e);
            }

            this.trigger('button:click', button, e);
        },

        setBody: function(view) {
            this.bodyView = view;
        },
        //overrides LayerView's set element and uses append vs prepend.
        setElement: function(element, delegate) {
            Layout.prototype.setElement.call(this, element, delegate);
            if (this.collisionMode === STACK) {
                $('body').append(this.$el);
            } else {
                $('body').prepend(this.$el);
            }
        },

        setIndex: function(index) {
            this.ui.mask.css('z-index', index);
            this.ui.modal.css('z-index', index + 1);
        }
    });
});

